import { Component } from '@angular/core';

@Component({
  selector: 'app-cat-compose-parent',
  template: '<router-outlet></router-outlet>',
  standalone: false,
})
export class CatComposeParentComponent {}
